module.exports = __webpack_public_path__ + "static/media/img2-1.b50a6309.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_foliar/B/img2-1.png
// module id = 1279
// module chunks = 3